export default __webpack_public_path__ + "cta-bar.png";